import { render, staticRenderFns } from "./metadataModal.vue?vue&type=template&id=52079bde"
import script from "./metadataModal.vue?vue&type=script&lang=js"
export * from "./metadataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports